import { FC } from 'react';
import clsx from 'clsx';

import {
  Link,
  urls,
  IconCheckmark,
  IconCollapse,
} from '@getstream/ui-library/build';

import { ButtonAnimatedLogo } from '../ButtonAnimatedLogo';
import { Incompleted } from '../Icons';

import { useGetStartedContext } from '../GetStarted/GetStarted.context';

import { Step } from '../../../types/tour';

import styles from './ProgressSidebar.module.css';

export type Props = {
  title: string;
  leaveTourLink: string;
  current: number;
  steps: Step[];
};

export const ProgressSidebar: FC<Props> = ({
  title,
  steps,
  current,
  leaveTourLink,
}) => {
  const { goTo } = useGetStartedContext();

  return (
    <div className={styles.sidebar}>
      <ul className="flex flex-col">
        <li className="flex flex-col border-b border-grey-lightest p-6 var-bold text-black-06 lg:hidden">
          <Link to={leaveTourLink}>
            <IconCollapse />
          </Link>
        </li>
        <li className="flex flex-col border-b border-grey-lightest p-6 pr-2 var-bold text-black-06 hidden lg:flex lg:flex-row lg:items-center lg:justify-between lg:h-90">
          <ButtonAnimatedLogo label="leave tour" to={leaveTourLink} />
          <span className="bg-lightblue rounded-tag text-stream text-2xs uppercase var-bold px-2 py-1">
            {title}
          </span>
        </li>
        {steps.map(({ id, completed, label, steps }, index) => {
          return (
            <li
              key={id}
              className={clsx(styles.step, {
                ['items-start text-black-09 ']: id === current,
              })}
            >
              <div
                className={clsx('flex', {
                  ['cursor-pointer']: completed && index !== 0,
                })}
                onClick={
                  completed && index !== 0 ? () => goTo(index) : undefined
                }
              >
                <span
                  className={clsx('text-grey', {
                    ['text-stream']: id === current,
                  })}
                >
                  {completed ? (
                    <IconCheckmark square blue width={20} />
                  ) : (
                    <span>
                      {id < 10 ? '0' : undefined}
                      {id}
                    </span>
                  )}
                </span>
                <span className="hidden lg:block lg:ml-4">{label}</span>
              </div>
              {steps && id === current ? (
                <ul className={styles.progressSidebarNestedList}>
                  {steps.map((nestedStep) => {
                    return (
                      <li className="mt-4" key={nestedStep.id}>
                        <div className="flex">
                          <span className="text-grey">
                            {nestedStep.completed ? (
                              <IconCheckmark square blue width={20} />
                            ) : (
                              <Incompleted />
                            )}
                          </span>
                          <span className="hidden lg:block lg:ml-4">
                            {nestedStep.label}
                          </span>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              ) : null}
            </li>
          );
        })}
      </ul>
      <div
        className={
          'hidden justify-center items-center border-t border-grey-lightest p-6 font-bold  h-90 lg:flex'
        }
      >
        <Link href={urls.contact}>Talk to sales</Link>
      </div>
    </div>
  );
};
